import { gettext } from "@/plugins/gettext"

const $gettext = gettext.$gettext
export const langTypes = [
  { id: "en_US", name: "en" },
  { id: "fr_FR", name: "fr" },
]

export const siteList = [
  {
    id: 1,
    acronym: "MM",
    name: $gettext("Meilleurs Masters"),
    siteUrl: import.meta.env.VITE_SITE_MM,
  },
  {
    id: 3,
    acronym: "MB",
    name: $gettext("Meilleurs Bachelors"),
    siteUrl: import.meta.env.VITE_SITE_MB,
  },
  {
    id: 5,
    acronym: "BOC",
    name: $gettext("BO Commercial"),
    siteUrl: import.meta.env.VITE_SITE_BOC,
  },
  {
    id: 6,
    acronym: "BOE",
    name: $gettext("BO Enquête"),
    siteUrl: import.meta.env.VITE_SITE_BOE,
  },
]

export const IS_MM_REPORTS_LIST = 0
export const IS_MB_REPORTS_LIST = 0
export const IS_ALL_REPORTS_LIST = 1
export const IS_REPORTS_CURRENT_YEAR = 1

export const IS_SHOW_REPORTS = 1